<div class="grid p-0 px-2 mb-5 lg:mb-3 mt-0 md:p-1">
	<div class="col-12">
		<p-table #tableDtmfList dataKey="ObjId" [value]="mtmaDtmfs" [lazy]="true" (onLazyLoad)="loadDtmfs($event)"
			[paginator]="true" [totalRecords]="totalRecords" [loading]="dtmfsLoading" [rows]="pageSize"
			[showCurrentPageReport]="true" currentPageReportTemplate="{{ 'TABLE_REPORT' | translate }}" [autoLayout]="true"
			responsiveLayout="stack" sortField="Code" [sortOrder]="1">
			<ng-template pTemplate="caption">
				<div class="grid">
					<div [class]="actionLayout('left')">
						<!-- <button pButton pRipple icon="pi cm-plus" [disabled]="resultLength >= maxMemorySize || isActiveTask || availableActions()"
									label="{{ 'ADD_DTMF' | translate }}" (click)="addDtmf()"
									class="p-button-primary text-normal border-transparent font-medium py-1">
							</button> -->
						<p-button id="addMtmaDtmf" label="{{ 'ADD_DTMF' | translate }}" (click)="addDtmf()"
							[disabled]="resultLength >= maxMemorySize || isActiveTask || availableActions()" icon="pi cm-plus"
							[rounded]="false" [text]="true" severity="primary" styleClass="font-bold border-primary">
						</p-button>
					</div>
					<div [class]="actionLayout('center')">
						<div class="flex flex-column justify-content-center gap-2">
							<span class="flex align-items-center justify-content-center">
								<i class="pi cm-memory-storage mr-1"></i>
								{{'MEMORY_USAGE' | translate }}: {{memorySize}} / {{maxMemorySize}}
							</span>
							<p-progressBar [value]="getValueMemory()">
								<ng-template pTemplate="content" let-value>
									<span *ngIf="getValueMemory() > 4">{{getValueMemory()}} %</span>
								</ng-template>
							</p-progressBar>
						</div>
					</div>
					<div [class]="actionLayout('right')">
						<span class="p-input-icon-left" [class]="dynamicInputSearchWidth()">
							<i class="pi cm-search"></i>
							<input [formControl]="searchFilter" pInputText type="text" id="customers-input-search"
								placeholder="{{ 'SEARCH' | translate }}" [ngClass]="dynamicInputSearchWidth()"
								maxlength="254" />
						</span>
					</div>
				</div>
			</ng-template>
			<ng-template pTemplate="header" class="flex align-items-center justify-content-center">
				<tr>
					<th>
						<div pSortableColumn="Code" class="flex align-items-center justify-content-center">{{ 'CODE' |
							translate }}
							<p-sortIcon field="Code"></p-sortIcon>
						</div>
					</th>
					<th>
						<div pSortableColumn="Description" class="flex align-items-center justify-content-center">{{
							'DESCRIPTION' |
							translate }}
							<p-sortIcon field="Description"></p-sortIcon>
						</div>
					</th>
					<th>
						<div class="flex align-items-center justify-content-center">{{ 'ACTION' | translate }}</div>
					</th>
				</tr>
			</ng-template>
			<ng-template pTemplate="body" let-dtmf>
				<tr>
					<td>
						<span class="p-column-title font-semibold">{{ 'CODE' | translate }}</span>
						<div class="flex align-items-center justify-content-center">{{ dtmf.Code }}</div>
					</td>
					<td>
						<span class="p-column-title font-semibold">{{ 'DESCRIPTION' | translate }}</span>
						<div class="flex align-items-center justify-content-center">{{ dtmf.Description }}</div>
					</td>
					<td>
						<span class="p-column-title font-semibold">{{ 'ACTION' | translate }}</span>
						<div class="flex align-items-center justify-content-center">{{ getTextAction(dtmf) }}</div>
					</td>
					<td>
						<span class="p-column-title"></span>
						<div class="flex flex-row justify-content-center align-items-center gap-1">
							<p-button pTooltip="{{ 'EDIT' | translate}}" id="buttonDeviceDtmfEdit-{{dtmf.Name}}"
								[disabled]="dtmf.Fixed || isActiveTask" tooltipPosition="bottom" icon="pi cm-pencil"
								size="large" (click)="editDtmf(dtmf)" [rounded]="false" [text]="true" severity="secondary">
							</p-button>
							<p-button pTooltip="{{ 'DELETE' | translate}}" id="buttonDeviceDtmfDelete-{{dtmf.Name}}"
								[disabled]="dtmf.Fixed || isActiveTask" tooltipPosition="bottom" icon="pi cm-trash" size="large"
								(click)="delete(dtmf)" [rounded]="false" [text]="true" severity="danger">
							</p-button>
						</div>
					</td>
				</tr>
			</ng-template>
			<ng-template pTemplate="emptymessage">
				<tr>
					<td colspan="12">{{ 'TABLE_NO_ELEMENT' | translate }}</td>
				</tr>
			</ng-template>
		</p-table>
	</div>
</div>

<p-confirmDialog #confDialog>
	<ng-template pTemplate="footer">
		<div class="col-12 flex justify-content-center">
			<button type="button" pButton [label]="confDialog.acceptButtonLabel" [ngClass]="acceptButtonStyle"
				(click)="confDialog.accept()">
			</button>
			<button type="button" pButton [label]="confDialog.rejectButtonLabel" [ngClass]="rejectButtonStyle"
				(click)="confDialog.reject()">
			</button>
		</div>
	</ng-template>
</p-confirmDialog>